package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.EditOutline: ImageVector
    get() {
        if (_editOutline != null) {
            return _editOutline!!
        }
        _editOutline = Builder(name = "EditOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 11.0f, viewportHeight = 11.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(1.1667f, 9.3333f)
                horizontalLineTo(1.9979f)
                lineTo(7.7f, 3.6312f)
                lineTo(6.8688f, 2.8f)
                lineTo(1.1667f, 8.5021f)
                verticalLineTo(9.3333f)
                verticalLineTo(9.3333f)
                moveTo(0.0f, 10.5f)
                verticalLineTo(8.0208f)
                lineTo(7.7f, 0.3354f)
                curveTo(7.8167f, 0.2285f, 7.9455f, 0.1458f, 8.0865f, 0.0875f)
                curveTo(8.2274f, 0.0292f, 8.3757f, 0.0f, 8.5313f, 0.0f)
                curveTo(8.6868f, 0.0f, 8.8375f, 0.0292f, 8.9833f, 0.0875f)
                curveTo(9.1292f, 0.1458f, 9.2556f, 0.2333f, 9.3625f, 0.35f)
                lineTo(10.1646f, 1.1667f)
                curveTo(10.2812f, 1.2736f, 10.3663f, 1.4f, 10.4198f, 1.5458f)
                curveTo(10.4733f, 1.6917f, 10.5f, 1.8375f, 10.5f, 1.9833f)
                curveTo(10.5f, 2.1389f, 10.4733f, 2.2871f, 10.4198f, 2.4281f)
                curveTo(10.3663f, 2.5691f, 10.2812f, 2.6979f, 10.1646f, 2.8146f)
                lineTo(2.4792f, 10.5f)
                horizontalLineTo(0.0f)
                verticalLineTo(10.5f)
                moveTo(9.3333f, 1.9833f)
                verticalLineTo(1.9833f)
                lineTo(8.5167f, 1.1667f)
                verticalLineTo(1.1667f)
                lineTo(9.3333f, 1.9833f)
                verticalLineTo(1.9833f)
                moveTo(7.2771f, 3.2229f)
                lineTo(6.8688f, 2.8f)
                verticalLineTo(2.8f)
                lineTo(7.7f, 3.6312f)
                verticalLineTo(3.6312f)
                lineTo(7.2771f, 3.2229f)
                verticalLineTo(3.2229f)
            }
        }
        .build()
        return _editOutline!!
    }

private var _editOutline: ImageVector? = null
